import React from 'react'
import Step from '../../components/Step'
import ButtonsYesNo from '../../elements/ButtonsYesNo'
import Resi from '../Resi'
import {fieldName, routeName, enforce} from '../HelpersResi'
import HelpIcon from '../../elements/HelpIcon'


const fireExtinguishers = fieldName('fireExtinguishers');

export const rules = {
    [fireExtinguishers]:[
        enforce.required("Required")
    ]
}


export default () => {
    const navigation = Resi.useNavigation();
   
    return (
        <Step>
            <h2>Does the building have fire extinguishers? <HelpIcon label={fireExtinguishers} message=""/></h2>
            <ButtonsYesNo field={fireExtinguishers} callback={ navigation.goToNext } />
        </Step>
    )
}